/* eslint-disable react/prop-types */
import React from 'react';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Box from '@nubank/nuds-web/components/Box/Box';
import Collapse from '@nubank/nuds-web/components/Collapse/Collapse';
import Link from '@nubank/nuds-web/components/Link/Link';

const ContractFiles = ({ data }) => (
  <Box marginTop="16x">
    { data.map(row => {
      const { year, files, id } = row;

      return (
        <Collapse id={id} key={id}>
          <Collapse.Header>
            <Typography
              color="black.light"
              variant="heading4"
              strong
              paddingVertical="4x"
            >
              {year}
            </Typography>
          </Collapse.Header>
          <Collapse.Body>
            { files.map(file => (
              <Box
                marginBottom="6x"
                key={file.id}
              >
                <Link
                  key={file.id}
                  href={file.url}
                  typographyProps={{
                    color: 'primary.default',
                    variant: 'heading4',
                  }}
                  iconProps={{
                    name: 'download',
                  }}
                >
                  {file.title}
                </Link>
              </Box>
            ))}
          </Collapse.Body>
        </Collapse>
      );
    })}
  </Box>
);

export default ContractFiles;
